import u from 'umbrellajs'

// Re-route the button click to the anchor link while on mobile
export default function FixedFeedbackButton(){
  const $feedback = u('#fixed-feedback-button')

  const handleClick = e => {
    // @TODO: This is technically tied to the mobile view so its not really a hack per say
    // but this still should still just use a yet to be developed common responsive module
    const isMobile = window.matchMedia('(max-width: 767px)')
    if(!isMobile || e.target.tagName !== 'BUTTON'){ return }
    $feedback.toggleClass('open')
  }
  $feedback.on('click', handleClick)

  return () => {
    $feedback.off('click', handleClick)
  }
}
